import { boxList } from '../module/boxes'

export const getMyQuestionBankList = ({ questionBankState, userResponseState }) => {
  // return question bank array sorted by next available (by default)
  let questionBank = Object.keys(questionBankState.questionBank).map(id => {
    const userResponse = userResponseState.questionBank[id] || {}
    return {
      id,
      ...questionBankState.questionBank[id],
      ...userResponse,
      available: true,
    }
  })
  // TODO: sort
  return questionBank
}

export const getCurrentWorkout = ({ workoutState }) => {
  const { questionBankId, workoutComplete, workouts, displayAnswer } = workoutState
  const thisWorkout = workouts[questionBankId]
  if (!thisWorkout) {
    return {
      workoutComplete: false,
      displayAnswer: false,
      questions: [],
      questionIndex: 0,
    }
  } else {
    const { questions, questionIndex } = thisWorkout
    return {
      workoutComplete,
      displayAnswer,
      questions,
      questionIndex,
    }
  }
}

const getProgress = ({ questions = {}, responses = {} }) => {
  let questionCount = 0
  let questionResponseCount = 0
  const boxSpread = {}
  boxList.forEach(box => {
    boxSpread[box.id] = 0
  })

  if (questions) {
    Object.keys(questions).forEach(questionId => {
      questionCount += 1
      // loop through our questions and put the responses in to appropriate boxes
      const responseBoxId = responses[questionId]
      if (responseBoxId && boxSpread.hasOwnProperty(responseBoxId)) {
        questionResponseCount += 1
        boxSpread[responseBoxId] += 1
      }
    })
  }

  return {
    questionCount,
    questionResponseCount,
    boxSpread,
  }
}

export const getQuestionBankProgress = ({
  questionBankState,
  userResponseState,
  questionBankId,
}) => {
  const questionBank = questionBankState.questionBank[questionBankId]
  const { questions } = questionBank
  const questionBankResponse = userResponseState.questionBank[questionBankId]

  return getProgress({
    questions,
    responses: questionBankResponse ? questionBankResponse.responses : {},
  })
}

export const getWorkoutProgress = ({ workout }) => {
  const { questions } = workout
  const questionMap = {}
  const responses = {}
  questions.forEach(question => {
    questionMap[question.id] = question
    responses[question.id] = question.response
  })
  return getProgress({
    questions: questionMap,
    responses,
  })
}



// WEBPACK FOOTER //
// ./src/store/selectors.js